import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import Divider from './Divider'
import SummaryDataItem from './SummaryDataItem'

import FormatCurrency from 'components/Common/FormatCurrency'

type Props = {
  isBooked: boolean
  confirmationTitle?: string
  confirmationCode?: string
  priceTitle?: string
  price?: number
}

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
`

const LeftContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
`

function ConfirmationDetails({
  isBooked,
  confirmationTitle = 'Confirmation number',
  confirmationCode,
  priceTitle = isBooked ? 'Total paid' : 'Price',
  price,
}: Props) {
  if (!confirmationCode && !price) return null
  return (
    <>
      <Divider />
      <Wrapper>
        <LeftContent>
          <SummaryDataItem title={confirmationTitle} value={confirmationCode} />
          {price && (
            <SummaryDataItem
              title={priceTitle}
              value={<FormatCurrency value={price} />}
            />
          )}
        </LeftContent>
      </Wrapper>
    </>
  )
}

export default ConfirmationDetails
